var _psPatientsTheme$spac;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import * as components from "../muiOverrides/components";
import { createTheme } from '@mui/material';
import { psPatientsTheme } from "./sc-vars-patients";
var _createTheme = createTheme(),
  spacing = _createTheme.spacing;
export var psConsoleV2 = _objectSpread(_objectSpread({
  name: 'Console-v2'
}, psPatientsTheme), {}, {
  components: _objectSpread(_objectSpread(_objectSpread({}, components), psPatientsTheme.components), {}, {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2196F3'
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          paddingBottom: spacing((psPatientsTheme === null || psPatientsTheme === void 0 || (_psPatientsTheme$spac = psPatientsTheme.spaces) === null || _psPatientsTheme$spac === void 0 ? void 0 : _psPatientsTheme$spac.big) || 4)
        }
      }
    }
  })
});
//# sourceMappingURL=sc-vars-console-v2.js.map